import { Stack } from "expo-router";
import { COLORS } from "../../lib/brand";
import Head from "expo-router/head";

import { CampusShell } from "../../components/campus/CampusShell";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { PortalGate } from "../../lib/PortalGate";

const BLACK = COLORS.BLACK.hex;

export default function CampusLayout() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <PortalGate portal="campus">
        <CampusShell>
          <ErrorBoundary boundaryName="campus">
            <Stack
              screenOptions={{
                headerShown: false,
                contentStyle: { backgroundColor: BLACK },
                animation: "none",
              }}
            />
          </ErrorBoundary>
        </CampusShell>
      </PortalGate>
    </>
  );
}
